<div class="reentrega-lote container-fluid">
  <h3>Reentrega em Lote</h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <div class="d-flex flex-wrap align-items-center justify-content-start filtros-header">
          <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm">
            <mat-form-field style="max-width: 500px;">
              <mat-label>Justificativa*:</mat-label>
              <input maxlength="135" matInput formControlName="justificativa" />
            </mat-form-field>
          </form>
          &nbsp;
          <button mat-raised-button type="button" color="primary" (click)="downloadExcelTemplate()"
            [disabled]="isLoadingDownload" matTooltip="Download template Excel">
            <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
              <mat-spinner diameter="20" color="dark"></mat-spinner>
              &nbsp; Baixando
            </span>
            <span *ngIf="!isLoadingDownload">
              <i class="far fa-file-excel search-button cursor-pointer-icon"></i> Template 
            </span>
          </button>
          <label for="fileUpload">
            <a mat-raised-button class="upload" [disabled]="filterForm.invalid || isLoading"
              matTooltip="Importar um arquivo Excel" upload>
              <i class="fas fa-upload"></i>&nbsp;
              Importar Planilha
            </a>
          </label>
          <span *ngIf="filename">Arquivo: <span class="filename">{{ filename }}</span></span>
          <input type="file" id="fileUpload" name="fileUpload" accept=".xls, .xlsx, .csv"
            (change)="selecionarArquivo($event)" hidden />
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content [hidden]="isLoading || !reentregaConsultaGrid?.data?.length" class="no-padding">
      <h3 class="text-center w-100 mt-3">Inconsistências encontradas no arquivo {{filename}}</h3>
      <div>
        <table id="importadosTable" mat-table [dataSource]="reentregaConsultaGrid" class="table-sm">
          <ng-container matColumnDef="linhaArquivo">
            <th mat-header-cell *matHeaderCellDef>Linha</th>
            <td mat-cell *matCellDef="let reentregaLote">
              {{ reentregaLote.linhaArquivo }}
            </td>
          </ng-container>

          <ng-container matColumnDef="inconsistencia">
            <th mat-header-cell *matHeaderCellDef>Inconsistência</th>
            <td mat-cell *matCellDef="let reentregaLote">
              {{ reentregaLote.inconsistencia }}
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator #paginator [pageSizeOptions]='[10,20,50]'></mat-paginator>

      <!-- <div *ngIf="!isLoading && ReentregaConsultaGrid?.data?.length === 0"
        class="d-flex justify-content-center align-items-center" style="height: 100px">
        Nenhuma Reentrega em Lote encontrada!
      </div> -->

    </mat-card-content>
  </mat-card>
</div>
